document.querySelectorAll(".timer").forEach((timerEl) => {
  let time = parseInt(timerEl.getAttribute("data-time"));

  const interval = setInterval(() => {
    let minutes = Math.floor(time / 60);
    let seconds = time % 60;

    minutes = minutes < 10 ? "0" + minutes : minutes;
    seconds = seconds < 10 ? "0" + seconds : seconds;

    timerEl.textContent = `${minutes}:${seconds}`;

    if (time <= 0) {
      clearInterval(interval);
    }

    time--;
  }, 1000);
});



//scroll

// Select all buttons that should trigger scroll
const buttons = document.querySelectorAll(".scroll-to-atc");

// Target section
const target = document.getElementById("atc");

// Attach click event to each button
buttons.forEach(btn => {
  btn.addEventListener("click", () => {
    target.scrollIntoView({
      behavior: "smooth",
      block: "start"
    });
  });
});